'use client';

import { LinkedInIcon, XIcon, FacebookIcon, LinkIcon } from '@/assets';
import { useEffect, useState } from 'react';
import {
  LinkedinShareButton,
  TwitterShareButton,
  FacebookShareButton,
} from 'react-share';

interface Props {
  className?: string;
  bgColor?: string;
  fill?: string;
}

export const ShareOnSocialMedia = (props: Props) => {
  const [url, setUrl] = useState('');
  useEffect(() => {
    setUrl(window.location.href);
  }, []);
  const copyUrl = () => {
    navigator.clipboard.writeText(url);
    alert('Copied URL to clipboard');
  };

  return (
    <div className={props.className}>
      <button
        className={`rounded-[50%] p-1 ${props.bgColor ? props.bgColor : 'bg-primary-light-grey'}`}
        onClick={() => copyUrl()}
        aria-label="Copy URL to clipboard"
      >
        <LinkIcon fill={`${props.fill ? props.fill : 'black'}`}></LinkIcon>
      </button>
      <LinkedinShareButton url={url}>
        <div
          className={`rounded-[50%] p-1 ${props.bgColor ? props.bgColor : 'bg-primary-light-grey'}`}
        >
          <LinkedInIcon
            fill={`${props.fill ? props.fill : 'black'}`}
          ></LinkedInIcon>
        </div>
      </LinkedinShareButton>
      <TwitterShareButton url={url}>
        <div
          className={`rounded-[50%] p-1 ${props.bgColor ? props.bgColor : 'bg-primary-light-grey'}`}
        >
          <XIcon fill={`${props.fill ? props.fill : 'black'}`}></XIcon>
        </div>
      </TwitterShareButton>
      <FacebookShareButton url={url}>
        <div
          className={`rounded-[50%] p-1 ${props.bgColor ? props.bgColor : 'bg-primary-light-grey'}`}
        >
          <FacebookIcon
            fill={`${props.fill ? props.fill : 'black'}`}
          ></FacebookIcon>
        </div>
      </FacebookShareButton>
    </div>
  );
};
